import React from 'react';
import './SkeletonBlock.css';

const joinClasses = (...classes) => classes.filter(Boolean).join(' ');

const SkeletonBlock = ({
  width = '100%',
  height = '1rem',
  radius,
  circle = false,
  className,
  style,
  inline = false,
}) => {
  const resolvedStyle = {
    width,
    height,
    borderRadius: circle ? '999px' : radius,
    ...style,
  };

  const combinedClassName = joinClasses(
    'skeleton-block',
    inline && 'skeleton-block--inline',
    circle && 'skeleton-block--circle',
    className,
  );

  return <span className={combinedClassName} style={resolvedStyle} aria-hidden="true" />;
};

export default SkeletonBlock;
